<app-modal
  *ngIf="mainContent && primaryAction"
  [modalTitle]="'general.investmentQualification'"
  [mainContentTemplate]="mainContent"
  [primaryActionTemplate]="primaryAction"
  (closed)="activeModal.dismiss()"
></app-modal>

<ng-template #mainContent>
  <label class="mb-2"
    >{{
      "registrationWizard.investorRatingModal.experiencedFinish.congratInfo"
        | translate
          : {
              date:
                store.user()?.investorQualificationLastDate
                | date : "yyyy.MM.dd"
            }
    }}
  </label>
  <label class="mb-0"
    >{{
      "registrationWizard.investorRatingModal.experiencedFinish.congratDecription"
        | translate
    }}
  </label>
</ng-template>

<ng-template #primaryAction>
  <button
    class="btn btn-primary btn-sm"
    type="submit"
    (click)="handlePrimaryAction()"
  >
    {{ "registrationWizard.continueRegistration" | translate
    }}<span class="ms-2" data-fa-transform="shrink-3"> </span>
  </button>
</ng-template>
